exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n::v-deep .v-dialog[data-v-e5e516c6]{position:relative\n}", ""]);

// exports
